<div class="container main-container">

    <mat-card class="card-light">
        <mat-card-title>
            {{ 'CANCEL_USER_DELETE_COMPONENT.TITLE' | translate }}
        </mat-card-title>
        <mat-card-content>
            <ng-container *ngIf="result">
                <div *ngIf="msg === ''">
                    <p>{{ 'CANCEL_USER_DELETE_COMPONENT.SUCCESS_MESSAGE' | translate }}</p>
                </div>

                <div *ngIf="msg">
                    <p>{{ msg }}</p>
                </div>
            </ng-container>


        </mat-card-content>
        <mat-card-footer>
            <div class="action-buttons">
                <a mat-flat-button [routerLink]="['/']" color="primary">
                    {{ 'CANCEL_USER_DELETE_COMPONENT.BACK_TO_MAIN' | translate }}
                </a>
            </div>
        </mat-card-footer>
    </mat-card>

</div>
